import { Component, OnInit } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { IUser } from '../interfaces/IUser';
import { UserService } from '../service/user.service';
import { AuthService } from '../service/auth.service';
import { NotificationService } from '../service/notification.service';
import { ToastModule } from "primeng/toast";
import { NgIf } from "@angular/common";
import { UtilsService } from "../service/utils.service";

@Component({
    selector: 'app-edit-user-profile',
    standalone: true,
    templateUrl: './edit-user-profile.component.html',
    imports: [DialogModule, InputTextModule, ButtonModule, FormsModule, ReactiveFormsModule, ToastModule, NgIf],
})
export class EditUserProfileComponent implements OnInit {
    editUserProfileFrom: FormGroup | any;
    visible: boolean = false;
    emailPattern: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    constructor(
        private formBuilder: FormBuilder,
        private userService: UserService,
        private authService: AuthService,
        private ns: NotificationService,
        public utilsService: UtilsService
    ) {
    }

    async ngOnInit() {
        this.createForm();
    }

    createForm() {
        this.editUserProfileFrom = this.formBuilder.group({
            usr_first_name_str: ['', Validators.required],
            usr_last_name_str: ['', Validators.required],
            usr_email_str: <any>['', Validators.compose([Validators.required, Validators.pattern(this.emailPattern)])],
            usr_mobile_number_num: <any>['', [Validators.required, Validators.maxLength(10)]],
            usr_pin_str: <any>[''],
            pin1: ['', Validators.required],
            pin2: ['', Validators.required],
            pin3: ['', Validators.required],
            pin4: ['', Validators.required],
            pin5: ['', Validators.required],
            pin6: ['', Validators.required],
        });
    }

    async userDialog() {
        this.visible = true;
        let res = <any>await this.userService.getByIdNew(<any>this.authService.getUserId());
        delete res.usr_pin_str;
        this.editUserProfileFrom.patchValue(res);
    }

    async updateProfile() {
        let userPin: any = '';
        for (let pin of this.utilsService.userPin) {
            userPin = userPin + pin.value;
        }
        if (userPin.length < 6) return;
        const formData: IUser = this.editUserProfileFrom.getRawValue();
        this.deletePinData(formData);
        formData.usr_pin_str = userPin;
        delete formData.usr_email_str;
        let res = await this.userService.updateUser(<any>this.authService.getUserId(), formData, { select: '_id' });
        if (res) {
            this.ns.showSuccess('User updated successfully.')
            this.visible = false;
            setTimeout(() => {
                this.authService.logout()
            }, 1000)
        }
    }

    deletePinData(formData: any) {
        delete formData.pin1;
        delete formData.pin2;
        delete formData.pin3;
        delete formData.pin4;
        delete formData.pin5;
        delete formData.pin6;
        return formData;
    }

}
